<template>
    <div>
        <input 
            type="text" 
            :name="name" 
            style="display: none;" 
            v-model="datetime">
        <div class="form-row mx-0">
            <div class="col-md">
                <date-picker 
                    v-model="date" 
                    class="form-control-sm"
                    placeholder="dd-mm-yyyy"></date-picker>
                <small class="text-center d-block"></small>
            </div>
            <div class="col-md">
                <div class="form-inline">
                    <div class="form-group mb-0" style="width: 60px;">
                        <input 
                            type="number" 
                            min="-1" 
                            max="24" 
                            class="form-control form-control-sm w-100"
                            placeholder="hh"
                            v-model="hour"
                            maxlength="2"
                            noCounter>
                        <div class="w-100">
                            <small class="text-center d-block">hora</small>
                        </div>
                    </div>

                    <div class="form-group mb-0 ml-1 mr-1">
                        <p>:</p>
                        <hr>
                    </div>

                    <div class="form-group mb-0" style="width: 60px;">
                        <input 
                            type="number" 
                            min="-1" 
                            max="60" 
                            class="form-control form-control-sm w-100"
                            placeholder="mm" 
                            v-model="minute"
                            maxlength="2"
                            noCounter>
                        <div class="w-100">
                            <small class="text-center d-block" for="">minuto</small>
                        </div>
                    </div>

                    <!--<div class="form-group mb-0 ml-1 mr-1" style="display: none;">
                        <p>:</p>
                        <hr>
                    </div>

                    <div class="form-group mb-0" style="width: 60px;">
                        <input 
                            type="number" 
                            min="-1" 
                            max="60" 
                            class="form-control form-control-sm w-100"
                            placeholder="ss"
                            v-model="second"
                            maxlength="2">
                        <div class="w-100">
                            <small class="text-center d-block">segundo</small>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['value', 'name'],

        mounted: function () {
            if(this.value == null || this.value == ''){
                var date = new Date();
                this.date = this.convertDate(date);
                this.hour = date.getHours();
                this.minute = 0;//date.getMinutes();
            }else{
                this.setDate(this.value);
            }
        },

        data() {
            return {
                date: '',
                hour: 0,
                minute: 0,
                second: 0,
                datetime: '',
            }
        },

        methods: {
            convertDate: function(date){
                return date.getDate() + "-" 
                + (((date.getMonth() +1) <= 9) ? "0"+(date.getMonth() +1) : date.getMonth() +1) + "-"
                + date.getFullYear();
            },

            convertDateTime: function(date, hour, minute, second){
                if(hour <= 9){
                    hour = '0'+parseInt(hour);
                }

                if(minute <= 9){
                    minute = '0'+parseInt(minute);
                }

                if(second <= 9){
                    second = '0'+parseInt(second);
                }

                return date + ' ' + hour + ':' + minute + ':' + second;
            },

            setDate: function(date){
                var dateArray = date.split('-');
                var day = parseInt(dateArray[0]);
                var month = parseInt(dateArray[1])-1;
                
                var arrayYearTime = dateArray[2].split(" ");
                var year = parseInt(arrayYearTime[0]);
                var arrayTime = arrayYearTime[1].split(":");
                var hour = parseInt(arrayTime[0]);
                var minute = parseInt(arrayTime[1]);
                var second = parseInt(arrayTime[2]);
                
                if(hour <= 9){
                    hour = '0'+parseInt(hour);
                }

                if(minute <= 9){
                    minute = '0'+parseInt(minute);
                }

                if(second <= 9){
                    second = '0'+parseInt(second);
                }

                var date = new Date();
                date.setFullYear(year);
                date.setMonth(month);
                date.setDate(day);

                date.setHours(hour);
                date.setMinutes(minute);
                date.setSeconds(second);

                this.date = this.convertDate(date);
                this.hour = date.getHours();
                this.minute = date.getMinutes();
            },

            transformDate: function(){
                var now = new Date();

                var date = this.date;
                if(date == null){
                    date = convertDate(now);
                }

                var hour = this.hour;
                if(hour == null){
                    hour = 0;
                }

                var minute = this.minute;
                if(minute == null){
                    minute = 0;
                }

                var second = this.second;
                if(second == null){
                    second = 0;
                }

                this.datetime = this.convertDateTime(date, hour, minute, second);
            },

            addDay: function(){
                var parts = this.date.split("-");
                var day = parseInt(parts[0])+1;
                var month = parseInt(parts[1]);
                var year = parseInt(parts[2]);

                this.date = this.convertDate(new Date(year, (month - 1), day));
            },

            removeDay: function(){
                var parts = this.date.split("-");
                var day = parseInt(parts[0])-1;
                var month = parseInt(parts[1]);
                var year = parseInt(parts[2]);

                this.date = this.convertDate(new Date(year, (month - 1), day));
            }
        },

        watch: {
            date: function (value) {
                this.transformDate();
            },

            hour: function(value){
                if(value>=24){
                    this.hour = 0;
                    this.addDay();
                }

                if(value<=-1){
                    this.hour = 23;
                    this.removeDay();
                }

                this.transformDate();
            },

            minute: function(value){
                if(value>=60){
                    this.minute = 0;
                    this.hour++;
                }

                if(value<=-1){
                    this.minute = 59;
                    this.hour--;
                }

                this.transformDate();
            },

            second: function(value){
                if(value>=60){
                    this.second = 0;
                    this.minute++;
                }

                if(value<=-1){
                    this.second = 59;
                    this.minute--;
                }

                this.transformDate();

            },

            datetime: function(value){
                this.$emit('input', value);
            },

            value: function (value) {
                if(value == null || value == ''){
                    var date = new Date();
                    this.date = this.convertDate(date);
                    this.hour = date.getHours();
                    this.minute = 0;//date.getMinutes();
                }else{
                    this.setDate(value);
                }

            }
        },
    }
</script>